import React from 'react';
import {
  FaFacebook,
  FaTwitter,
  FaLinkedin,
  FaGithub,
  FaYoutube,
  FaInstagram,
  FaTiktok,
} from 'react-icons/fa';

const Social = () => {
  return (
    <div className="bg-gray-100 py-8 px-4">
      <div className="max-w-5xl mx-auto text-center">
        <p className="text-md font-thin text-gray-800 mb-4">
          Powered by <a href='https://www.facebook.com/profile.php?id=100095237342087' className="text-blue-500 text-lg">CodeStart</a> —
          experts in cutting-edge software development and next-gen AI tools to
          optimize your digital experience.
        </p>

        <div className="flex justify-center gap-8 mt-6">
          <a
            href="https://www.facebook.com/profile.php?id=100095237342087"
            target="_blank"
            rel="noopener noreferrer"
            className="text-blue-600 hover:text-blue-800 transition duration-300 ease-in-out transform hover:scale-110"
          >
            <FaFacebook size={28} />
          </a>

          <a
            href="https://twitter.com/sh_webdeveloper"
            target="_blank"
            rel="noopener noreferrer"
            className="text-blue-400 hover:text-blue-600 transition duration-300 ease-in-out transform hover:scale-110"
          >
            <FaTwitter size={28} />
          </a>

          <a
            href="https://www.linkedin.com/in/shokrullah-kosha-124b71284"
            target="_blank"
            rel="noopener noreferrer"
            className="text-blue-700 hover:text-blue-900 transition duration-300 ease-in-out transform hover:scale-110"
          >
            <FaLinkedin size={28} />
          </a>

          <a
            href="https://github.com/Koshaweb"
            target="_blank"
            rel="noopener noreferrer"
            className="text-gray-900 hover:text-gray-700 transition duration-300 ease-in-out transform hover:scale-110"
          >
            <FaGithub size={28} />
          </a>

          <a
            href="https://www.youtube.com/@codestart-f9p"
            target="_blank"
            rel="noopener noreferrer"
            className="text-red-600 hover:text-red-800 transition duration-300 ease-in-out transform hover:scale-110"
          >
            <FaYoutube size={28} />
          </a>

          <a
            href="https://www.instagram.com/codestart_au"
            target="_blank"
            rel="noopener noreferrer"
            className="text-pink-500 hover:text-pink-700 transition duration-300 ease-in-out transform hover:scale-110"
          >
            <FaInstagram size={28} />
          </a>

          <a
            href="https://www.tiktok.com/@codestart01?lang=en"
            target="_blank"
            rel="noopener noreferrer"
            className="text-black hover:text-gray-700 transition duration-300 ease-in-out transform hover:scale-110"
          >
            <FaTiktok size={28} />
          </a>
        </div>
      </div>
    </div>
  );
};

export default Social;
